<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCpestado" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objCpEstado.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCpEstado.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Pais">País</label>
                            <select @change="SetClavePais()" name="Pais" id="Pais" class="form-control form-select" v-model="objCpEstado.IdPais">
                                <option value="">Seleccione una opción</option>
                                <option v-for="(item, index) in Paises" :key="index" :value="item.IdPais">{{ item.Clave }} - {{ item.Nombre }}</option>
                            </select>
							<!-- <input type="text" v-model="objCpEstado.IdPais" class="form-control" id="IdPais" placeholder="Ingresar Clave" /> -->
							<CValidation v-if="this.errorvalidacion.IdPais" :Mensaje="'*'+errorvalidacion.IdPais[0]"/>
						</div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="ClavePais">Clave Pais</label>
							<input type="text" v-model="objCpEstado.ClavePais" class="form-control" id="ClavePais" placeholder="Ingresar Clave" readonly />
                        </div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCpEstado',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpEstado: {
				IdEstado: 0,
                IdPais:'',
                ClavePais:'',
				Nombre: '',
				Clave: '',
            },
            Paises:[],
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpEstado.IdEstado == 0) {
				await this.$http.post(
					'cpEstados',this.objCpEstado
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpEstados/'+this.objCpEstado.IdEstado,
					this.objCpEstado
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpEstados/"+this.objCpEstado.IdEstado
            ).then((res) => {
                this.objCpEstado = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpEstado.Fecha.replace(/-/g,'\/');
                this.objCpEstado.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        SetClavePais(){
            if(this.objCpEstado.IdPais){
                let pais = this.Paises.find(elem => elem.IdPais === this.objCpEstado.IdPais);
                this.objCpEstado.ClavePais = pais.Clave;
            } else {
                this.objCpEstado.ClavePais = '';
            }
        },
        GetComboPaises(){
            this.$http.get('cpPaises',{params:{
                simple:true,
            }}).then((res)=> {
                this.Paises = res.data.data;
            }).catch(err => console.error(err));
        },
        Limpiar()
        {
            this.objCpEstado = {
                IdEstado: 0,
                IdPais:'',
                ClavePais:'',
				Nombre: '',
				Clave: '',
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;
        this.GetComboPaises();
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpEstado.IdEstado = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
